import {Component, Input} from '@angular/core';
import {BadgeColorsEnum} from '../../../../shared/interfaces/BadgeColorsEnum';
import {OrderHistoryStatusesEnum} from '../../../../shared/interfaces/OrderHistoryStatusesEnum';
import {IOrdersHistory} from '../../../../shared/interfaces/orders-history.inteface';
import {Router} from '@angular/router';
import {BaseTableDirective} from '../../../../shared/directives/base-table.directive';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-order-history-table',
  templateUrl: './order-history-table.component.html',
  styleUrls: ['./order-history-table.component.scss'],
})
export class OrderHistoryTableComponent extends BaseTableDirective {
  @Input() ordersHistoryList: IOrdersHistory[] = [];
  @Input() loading: boolean;

  tableColumns = {
    createDate: true,
    receivedDate: true,
    shippedDate: false,
    userFirstName: false,
    wholesalerName: false,
    purchaseOrder: false,
    invoiceNumber: false,
    ndcCount: true,
    orderStatus: true,
    csos: true,
  };

  BadgeColorsEnum = BadgeColorsEnum;
  OrderHistoryStatusesEnum = OrderHistoryStatusesEnum;

  constructor(
    private router: Router,
    protected store: Store,
  ) {
    super(store);
  }

  goToDetails(id: number): void {
    this.router.navigate(['inventory/order-history/details', id]);
  }

  receiveOrder(id: number): void {
    this.router.navigate(['inventory/receive-order', id]);
  }

  sortByColumn(columnName: string): void {
    this.ordersHistoryList = this.sort(this.ordersHistoryList, columnName);
  }
}
